import React, { useMemo, useState } from 'react';
import styles from './courses.module.scss';
import Card from './newCard/Card';
import { Program } from '../../types';
import ArrowsLeftRightIcon from '../../assets/icons/arrows_leftright.svg?react';
import { useMediaQuery } from 'react-responsive';
import { Pagination } from "antd";

type Props = {
  courses: Program[] | undefined;
  showEdit?: boolean;
  isParentApp?: boolean;
  handleDuplicateCourse?: (program: Program) => void
};

type Sorting = {
  // field: 'position' | 'lastUsed' | 'favorite';
  direction: 'asc' | 'desc';
};

const pageSize = 10;
function Courses(props: Props) {
  const { courses, showEdit, isParentApp, handleDuplicateCourse } = props;
  const [sorting, setSorting] = useState<Sorting | null>({ direction: 'asc' });
  const isMobile = useMediaQuery({ maxWidth: 915 });
  const [current, setCurrent] = useState(1);
  const [minIndex, setMinIndex] = useState(0);
  const [maxIndex, setMaxIndex] = useState(pageSize);

  const handleChangeSorting = () => () => {
    if (sorting!.direction === 'asc') {
      return setSorting({ direction: 'desc' });
    } else {
      return setSorting({ direction: 'asc' });
    }
  };
  const handleChange = (page: number) => {
    setCurrent(page);
    setMinIndex((page-1) * pageSize);
    setMaxIndex(page * pageSize);
  }

  const _data = useMemo(() => {
    if (!courses) return [];
    if (!sorting) return courses;
    const { direction } = sorting;
    const programs = [...courses];
    return programs.sort((a, b) => {
      if (a.favorite && !b.favorite) return -1;
      if (!a.favorite && b.favorite) return 1;
      const aOrder = a.order ?? 1000;
      const bOrder = b.order ?? 1000;
      return direction === 'asc' ? aOrder - bOrder : bOrder - aOrder;
    });
  }, [courses, sorting]);

  if (!courses) return null;

  return (
    <div className={styles.programs}>
      { isMobile ? '' : (
        <div className={styles.header}>
          <div />
          <div className={styles.headerFilter}>
            <div onClick={handleChangeSorting()} className={styles.filter}>
              <div className={styles.headerTitle}>Lesson</div>
              <ArrowsLeftRightIcon className={styles.filterIcon}/>
            </div>
          </div>
        </div>
      )}
      {_data.map((item, index) => 
        index >= minIndex &&
        index < maxIndex && (  
          <Card showEdit={showEdit} key={item.id} program={item} isParentApp={isParentApp} handleDuplicateCourse={handleDuplicateCourse}/>
        )
      )}
      <Pagination
        pageSize={pageSize}
        current={current}
        total={_data.length}
        onChange={handleChange}
        className={styles.pagination}
      />
    </div>
  );
}

export default Courses;
